import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


export function FormationNavigation({formationCompleted, formationStep}: {formationCompleted: boolean, formationStep: string}){
    /*
    If the formation is completed, return null;
    If the formation is not completed, return the navigation to the formation step.
    */
   const {t} = useTranslation("common");
   if (formationCompleted){
        return null;
   }
   const formationStepToInt = formationStep? Math.min(Math.max(parseInt(formationStep), 1), 6) : 1;
//    If
//    if the formation step is 6, return null
   return <div>
    <Link to={!formationStep? "/formation/welcome": `/formation/${formationStepToInt}`} className="text-orange-500 underline">
        {!formationStep? t("tutor-inscription-status.formation.go-to-formation"): t("tutor-inscription-status.formation.go-to-formation-step")}
    </Link>
   </div>
}



export function RendezVousPostFormationNavigation({completed, disabled}: {completed: boolean, disabled: boolean}){
    /*
    If the formation is completed, return null;
    If the formation is not completed, return the navigation to the formation step.
    */
   const {t} = useTranslation("common");
   if (completed){
        return null;
   }
   if (disabled){
        return <p className="text-red-500 bg-red-500/10 p-2 rounded-md">{t("tutor-inscription-status.rdv-post-formation.you-must-complete-the-formation-first")}</p>;
   }
//    if the formation step is 6, return null
   return <div className="mt-3">
    <a href={"https://calendly.com/tutoratvirtuel-diplomeavantlamedaille/rencontre-de-bienvenue-tuteurs-benevoles-dam"} target="_blank" rel="noreferrer" className="text-orange-500 underline">
        {t("tutor-inscription-status.rdv-post-formation.take-rdv")}
    </a>
    <p className="text-gray-500 text-xs">{t("tutor-inscription-status.rdv-post-formation.if-you-have-already-taken-rdv")}</p>
   </div>
}



export function RendezVousPostFormationNavigationLarge(){
    /*
    If the formation is completed, return null;
    If the formation is not completed, return the navigation to the formation step.
    */
   const {t} = useTranslation("common");
   return <div className="my-3 space-y-3 w-full">
    <a href={"https://calendly.com/tutoratvirtuel-diplomeavantlamedaille/rencontre-de-bienvenue-tuteurs-benevoles-dam"} 
    target="_blank"
    rel="noreferrer"
    className="text-orange-500 bg-orange-500/10 hover:bg-orange-500/20 py-3 px-4 block rounded-md w-full text-center">
        {t("tutor-inscription-status.rdv-post-formation.take-rdv")}
    </a>
    <p className="text-gray-500 text-xs">{t("tutor-inscription-status.rdv-post-formation.you-will-be-redirected-to-calendly")}</p>
   </div>
}